import ComponentDetailsHeader from "./header";
export default ComponentDetailsHeader;
